import React from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { portfolioStore } from '../stores/portfolio-store';
import { HomeUI } from '../ui/home-ui';
import { ChartData } from '../types';

export const HomeObserver: React.FC = observer(() => {
  const navigate = useNavigate();

  const generateColors = (count: number): string[] => {
    const baseColors = [
      '#3b82f6', '#ef4444', '#10b981', '#f59e0b', '#8b5cf6',
      '#06b6d4', '#84cc16', '#f97316', '#ec4899', '#6366f1',
    ];
    
    const colors = [];
    for (let i = 0; i < count; i++) {
      colors.push(baseColors[i % baseColors.length]);
    }
    return colors;
  };

  const getPortfolioChartData = (): ChartData[] => {
    const assets = portfolioStore.assetDisplayData;
    const colors = generateColors(assets.length);
    
    return assets.map((asset, index) => ({
      label: `${asset.name} (${asset.symbol.toUpperCase()})`,
      value: asset.marketValue,
      color: colors[index],
    }));
  };

  const handleEditAssetsClick = (): void => {
    navigate('/edit-assets');
  };

  return (
    <HomeUI
      totalAssets={portfolioStore.totalAssets}
      totalPortfolioValue={portfolioStore.totalPortfolioValue}
      totalCostBasis={portfolioStore.totalCostBasis}
      totalPnL={portfolioStore.totalPnL}
      totalPnLPercentage={portfolioStore.totalPnLPercentage}
      assetDisplayData={portfolioStore.assetDisplayData}
      portfolioChartData={getPortfolioChartData()}
      onEditAssetsClick={handleEditAssetsClick}
    />
  );
});
